import { render, staticRenderFns } from "./TableTaxonCoordinators.vue?vue&type=template&id=ae64dfc2&"
import script from "./TableTaxonCoordinators.vue?vue&type=script&lang=js&"
export * from "./TableTaxonCoordinators.vue?vue&type=script&lang=js&"
import style0 from "./TableTaxonCoordinators.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports